<script setup lang="ts">
import { useFetchAddressList } from '~/api/service/address/list/index.service'
import AccountPageTable from '~/components/@pages/accounts/AccountPageTable.vue'
import DetailsBox from '~/components/box/DetailsBox.vue'
import PageTitleHeader from '~/components/header/PageTitleHeader.vue'
import { UNIT } from '~/environment-variables/unit.const'
import BcPagination from '~/ui/Pagination/BcPagination.vue'
import { getBreadCrumb } from '~/utils/breadCrumbList'

const { pagination, rowPerPageList } = usePagination({
  page: 1,
  rowPerPage: 25
})

const { data, isLoading } = useFetchAddressList(pagination)

useSeoMeta(getMeta('Accounts', 'Explore accounts and addresses'))

useHead(getBreadCrumb())
</script>

<template>
  <PageTitleHeader
    title="Accounts"
    :sub-title="`by ${UNIT} Balance`"
  />

  <DetailsBox class="mt-8">
    Showing the top <span class="font-bold text-primary">{{ data?.viewCount }}</span> records from {{
      data?.totalCount
    }} results
    <template #pagination>
      <BcPagination
        v-model="pagination"
        :total-count="data?.VCNT"
        :row-per-page-list="rowPerPageList"
        hide-rows-per-page
      />
    </template>
  </DetailsBox>

  <Card class="mt-4">
    <AccountPageTable
      :rows="data?.addressList || []"
      :is-loading="isLoading"
      :row-cnt="pagination.rowPerPage"
    />
    <BcPagination
      v-model="pagination"
      :total-count="data?.VCNT"
      :row-per-page-list="rowPerPageList"
    />
  </Card>
</template>

<style scoped lang="scss">
</style>